import {
  generateFullViewerUrl,
  readProjectId,
  WEB_EDITOR_PARAMS,
} from "@/utils/redirects";
import { addWebEditorRedirectToUrl } from "@/utils/web-editor-redirect";
import { GUID } from "@faro-lotv/ielement-types";

/** Older WebEditor urls pair the mode with the project in the hash, e.g. /app#editor/<projectId> */
const WEB_EDITOR_HASH = /^#[^/]+\/([^/?]+)/;

/**
 * @returns the project a WebEditor url names, in either its query or its hash form
 * @param url to read
 */
function readWebEditorProject({ searchParams, hash }: URL): GUID | undefined {
  return (
    readProjectId(searchParams.get(WEB_EDITOR_PARAMS.project)) ??
    readProjectId(WEB_EDITOR_HASH.exec(hash)?.at(1))
  );
}

/**
 * Translates a WebEditor url into the viewer url showing the same project, marked as a redirect.
 *
 * @returns the viewer url, or undefined if the WebEditor url names no project
 * @param webEditorUrl the viewer was opened with
 */
export function createViewerUrlFromWebEditor(
  webEditorUrl: URL,
): URL | undefined {
  const projectId = readWebEditorProject(webEditorUrl);

  return projectId
    ? addWebEditorRedirectToUrl(generateFullViewerUrl(projectId))
    : undefined;
}
